(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reed-video-tiles"] && !Shopify.designMode) return;
  try {
    
function setupReedStories(){
 document.querySelectorAll('.reed-story').forEach(function(story){
  if(story.dataset.ready)return;
  story.dataset.ready='true';
  var play=story.querySelector('.reed-story__play'),close=story.querySelector('.reed-story__close');
  if(!play||!close)return;
  var poster=story.querySelector('.reed-story__poster'),player=story.querySelector('.reed-story__player'),video=player.querySelector('video');
  play.addEventListener('click',function(){poster.hidden=true;player.hidden=false;video.focus();video.play().catch(function(){});});
  function stop(){video.pause();player.hidden=true;poster.hidden=false;play.focus();}
  close.addEventListener('click',stop);
  player.addEventListener('keydown',function(event){if(event.key==='Escape')stop();});
 });
}
setupReedStories();
document.addEventListener('shopify:section:load',setupReedStories);

  } catch(e) { console.error(e); }
})();
})();
